module.exports = __webpack_public_path__ + "25f979470a886804dd51cd963bb9d892.png";